import { styled } from '@mui/material/styles';
import { Button, Theme } from '@mui/material';

// Styled components for MUI v5
export const StyledButton = styled(Button)<{ error?: boolean }>(({ theme, error }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 64,
  border: 'none',
  textTransform: 'uppercase',
  padding: '6px 16px',
  lineHeight: 1.75,
  cursor: 'pointer',
  fontWeight: 'bold',
  letterSpacing: '0.02857em',
  backgroundColor: theme.palette.common.white,
  boxShadow: 'none',
  color: error ? theme.palette.error.main : theme.palette.primary.main,
  '&:hover': {
    backgroundColor: error 
      ? theme.palette.error.light 
      : theme.palette.primary.light,
    color: theme.palette.common.white,
  },
}));

// Custom styles using sx prop approach
export const modalStyles = {
  root: {
    backgroundColor: 'white',
    textAlign: 'center',
  },
  titleAlert: {
    color: '#E45501',
    fontWeight: 700,
    fontSize: 20,
  },
  closeButton: (theme: Theme) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  }),
  dialogContent: {
    paddingBottom: 2.5,
    overflow: 'scroll',
    whiteSpace: 'pre-wrap',
  },
  dialogTitle: {
    textAlign: 'center',
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-around',
    gap: 1,
  },
  promoForm: {
    flexDirection: 'row',
    border: '1px solid #F1F1F1',
    padding: 1.875,
    marginBottom: 2.5,
  },
  divider: {
    marginBottom: 2.5,
  },
  ButtonCancel: {
    marginLeft: 1.875,
    marginRight: 1.875,
  },
};